import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';
import { TablerIconsModule } from 'angular-tabler-icons';

/** Tab-bar fija del modo Cabina (épica #186 / #191). Cuatro pestañas fijas; permisos ya validados al entrar al modo. */
@Component({
  selector: 'app-cabin-tab-bar',
  standalone: true,
  imports: [CommonModule, RouterModule, MatRippleModule, TablerIconsModule],
  templateUrl: './cabin-tab-bar.component.html',
  styleUrl: './cabin-tab-bar.component.scss',
})
export class CabinTabBarComponent {
  readonly tabs: { label: string; icon: string; link: string; queryParams?: Record<string, string> }[] = [
    {
      label: 'Pago con Ticket',
      icon: 'ticket',
      link: '/apps/PayDetection',
    },
    {
      label: 'Ocupación',
      icon: 'car',
      link: '/apps/ParkingOccupancy',
    },
    {
      label: 'Planilla de Caja',
      icon: 'arrows-exchange',
      link: '/apps/CashMovements',
    },
    {
      label: 'Detecciones',
      icon: 'camera',
      link: '/apps/Detection',
    },
  ];
}
